<evc-platform
  [inputLeftBar]="leftMenu()"
  [inputHelpMenu]="helpMenu()"
  [inputSettingsMenu]="settingsMenu()"
  [displayApplicationsIcon]="isOnline"
  [inputAppIdentification]="appIdentity"
  [displayUserMenu]="!isOnPremise"
  [inputForcedLayout]="topbarLayout"
  (isLeftbarOpenChange)="toggleLeftBar($event)"
>
  <div top-bar-extra-settings class="top-bar-settings">
    @if (applicationMode?.platform === desktop.platform) {
      @if(isDevelopment){
        <evc-button textContent="Reset Data" (click)="resetAppData()" size="small" buttonStyle="neutral"/>
        <app-zoom-control />
      }
      <app-desktop-menu/>
    }
    <app-locale-selector />
  </div>

  <ng-container leftbar-top-content leftbarTopContent />

  <div class="leftbar__tabs-content" appLeftbarContent [isLeftbarOpen]="isLeftbarOpen"></div>

  <ng-content/>
</evc-platform>
